"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Monetate_module_1 = tslib_1.__importDefault(require("./modules/Monetate.module"));
const CookieConsent_module_1 = tslib_1.__importDefault(require("./modules/CookieConsent.module"));
const loadMonetateRootModule = () => ({
    hasRouter: false,
    modules: [(0, Monetate_module_1.default)(), (0, CookieConsent_module_1.default)()],
});
exports.default = loadMonetateRootModule;
